import Arrow from './arrow.svg';
import IconAUFlag from './au-flag.svg';
import BenefitsSolutions from './benefits-solutions.svg';
import Book from './book-icon.svg';
import IconCanadaFlag from './canada-flag.svg';
import ChevronBlue from './chevron-blue.svg';
import Chevron from './chevron.svg';
import Close from './close.svg';
import CrewTalent from './crew-talent-background-actor-support-icon.svg';
import IconDesktop from './desktop-icon.svg';
import Download from './download.svg';
import IconEmail from './email-icon.svg';
import EPProductServices from './ep-product-services-icon.svg';
import LogoGoogleAuthenticator from './google-authenticator-icon.svg';
import IconGuides from './guides-icon.svg';
import IconAcademy from './icon-Academy.svg';
import IconACAPremier from './icon-ACAPremier.svg';
import IconAssetHub from './icon-AssetHub.svg';
import IconBenefitsSolutionsCrewAndTalent from './icon-BenefitsSolutions-CrewTalent.svg';
import IconBenefitsSolutionsProductionCompanies from './icon-BenefitsSolutions-ProductionCompanies.svg';
import IconBinaryMagnifier from './icon-binary-magnifier.svg';
import IconBlogBlue from './icon-blog-blue.svg';
import IconCanadaRateBook from './icon-CanadaRateBook.svg';
import IconCentralCasting from './icon-CentralCasting.svg';
import IconChat from './icon-chat.svg';
import IconCommunities from './icon-Communities.svg';
import IconCrewAndCasting from './icon-CrewAndCasting.svg';
import CrewTalentSupport from './icon-CrewTalentSupport.svg';
import IconCrewTools from './icon-CrewTools.svg';
import IconDiversityManagement from './icon-DiversityManagement.svg';
import IconEPCares from './icon-EPCares.svg';
import IconEPLive from './icon-EPLive.svg';
import IconOnLocation from './icon-EPOnLocation.svg';
import IconEPResidency from './icon-EPResidency.svg';
import IconExpertAdvice from './icon-ExpertAdvice.svg';
import IconFinancing from './icon-Financing.svg';
import IconIndustryNewsBlue from './icon-industry-news-blue.svg';
import IconLegalComplianceBlue from './icon-legal-compliance-blue.svg';
import Lightbulb from './icon-lightbulb.svg';
import IconMasterSeriesBlue from './icon-master-series-blue.svg';
import IconMMB from './icon-MMB.svg';
import IconMMS from './icon-MMS.svg';
import IconMyEp from './icon-MyEP.svg';
import IconNewsroomBlue from './icon-newsroom-blue.svg';
import IconPayroll from './icon-Payroll.svg';
import IconPayrollCanada from './icon-PayrollCanada.svg';
import IconProductionIncentives from './icon-ProdIncentives.svg';
import ProductSupport from './icon-ProductSupport.svg';
import ProductSupportWhite from './icon-ProductSupportWhite.svg';
import IconProjectFinancing from './icon-ProjectFinancing.svg';
import IconSmartResiduals from './icon-Residuals.svg';
import IconRiskSolutions from './icon-RiskSolutions.svg';
import SalesInquiries from './icon-SalesInquiries.svg';
import IconScenechronize from './icon-Scenechronize.svg';
import IconService from './icon-Service.svg';
import IconSickLeave from './icon-SickLeave.svg';
import IconSmartAccounting from './icon-SmartAccounting.svg';
import IconSmartHub from './icon-SmartHub.svg';
import IconSmartHubVault from './icon-SmartHubVault.svg';
import IconSmartPO from './icon-SmartPO.svg';
import IconSmartStart from './icon-SmartStart.svg';
import IconSmartTime from './icon-SmartTime.svg';
import IconSyncOnSet from './icon-SyncOnSet.svg';
import IconThePaymaster from './icon-ThePaymaster.svg';
import IconW2 from './icon-W2.svg';
import IconWMProduction from './icon-wm-Production.svg';
import LogoIdMobile from './id-logo.svg';
import LifeSaver from './life-saver.svg';
import Magnifier from './magnifier.svg';
import Mics from './mics.svg';
import IconIdMobile from './mobile-icon.svg';
import Newspaper from './newspaper.svg';
import Payroll from './payroll.svg';
import Phone from './phone.svg';
import Play from './play.svg';
import ProductSupportCard from './product-support-icon.svg';
import IconRelated from './related-icon.svg';
import Resume from './resume.svg';
import Settings from './settings.svg';
import IconSyncOnSetLogo from './synconset-logo.svg';
import Terms from './terms.svg';
import IconUKFlag from './uk-flag.svg';
import IconUSFlag from './us-flag.svg';

const icons = {
  Arrow,
  Close,
  SalesInquiries,
  CrewTalentSupport,
  ProductSupport,
  ProductSupportWhite,
  BenefitsSolutions,
  Book,
  IconBenefitsSolutionsCrewAndTalent,
  IconBenefitsSolutionsProductionCompanies,
  Chevron,
  ChevronBlue,
  Download,
  LifeSaver,
  Magnifier,
  Mics,
  Newspaper,
  Payroll,
  Play,
  Resume,
  Settings,
  Terms,
  IconAcademy,
  IconACAPremier,
  IconAssetHub,
  IconCentralCasting,
  IconCommunities,
  IconCrewAndCasting,
  IconCrewTools,
  IconDiversityManagement,
  IconEPCares,
  IconEPLive,
  IconFinancing,
  Lightbulb,
  IconMMB,
  IconMMS,
  IconMyEp,
  IconOnLocation,
  IconPayroll,
  IconProductionIncentives,
  IconRiskSolutions,
  IconScenechronize,
  IconService,
  IconSickLeave,
  IconSmartAccounting,
  IconSmartHub,
  IconSmartHubVault,
  IconSmartPO,
  IconSmartResiduals,
  IconSmartStart,
  IconSmartTime,
  IconSyncOnSet,
  IconThePaymaster,
  IconW2,
  IconWMProduction,
  IconCanadaRateBook,
  IconProjectFinancing,
  IconEPResidency,
  IconExpertAdvice,
  IconPayrollCanada,
  IconAUFlag,
  IconUKFlag,
  IconUSFlag,
  IconCanadaFlag,
  IconRelated,
  IconGuides,
  IconSyncOnSetLogo,
  LogoGoogleAuthenticator,
  LogoIdMobile,
  IconIdMobile,
  IconDesktop,
  IconEmail,
  IconBlogBlue,
  IconIndustryNewsBlue,
  IconLegalComplianceBlue,
  IconMasterSeriesBlue,
  IconNewsroomBlue,
  CrewTalent,
  ProductSupportCard,
  EPProductServices,
  IconBinaryMagnifier,
  IconChat,

  // TODO: Use correct svg icons for every link
  AdminServices: BenefitsSolutions,
  CrewTools: IconCrewTools,
  Communities: IconCommunities,
  EpLive: IconEPLive,
  EpOnLocation: IconOnLocation,
  FinancingServices: IconFinancing,
  LaborCompliance: BenefitsSolutions,
  MovieMagicBudgeting: IconMMB,
  MovieMagicScheduling: IconMMS,
  Paymaster: IconThePaymaster,
  Phone: Phone,
  ProductionIncentives: IconProductionIncentives,
  PurchaseOrders: IconSmartPO,
  Residuals: IconSmartResiduals,
  RiskSolutions: IconRiskSolutions,
  ScenechronizePoa: IconScenechronize,
  ScenechronizeSmartHub: IconSmartHub,
  SmartAccounting: IconSmartAccounting,
  Smartcards: BenefitsSolutions,
  Smartstart: IconSmartStart,
  Smarttime: IconSmartTime,
  Smartvault: IconSmartHubVault,
  SuperLoanOut: BenefitsSolutions,
  TaxCreditPlacement: BenefitsSolutions,
} as const;

export default icons;
